import { IDictionary } from '@bimser/core';
import HTTPRequest, { HTTPRequestConfig } from './HTTPRequest';

export interface IBaseServices extends IDictionary<HTTPRequestConfig> {
	login: HTTPRequestConfig;
	IntegrationManager: HTTPRequestConfig;
	hr: HTTPRequestConfig;
	socket: HTTPRequestConfig;
	web: HTTPRequestConfig;
}

const Services = HTTPRequest.getInstances<IBaseServices>();

export default Services;
